import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { OptimizedImage } from "@/components/ui/optimized-image";

const Hero = () => {
  return <section className="py-12 md:py-24 pb-8 md:pb-20 container mx-auto px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="space-y-6">
          <Badge variant="outline" className="border-godyspo-gold text-godyspo-gold px-3 py-1 text-sm animate-fade-in-stable">
            30-Day Free Trial
          </Badge>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight animate-fade-in-stable" style={{ animationDelay: '0.1s', animationFillMode: 'both' }}>
            The <span className="text-godyspo-gold gradient-text">Streamlined</span> Real Estate Sales Platform
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground animate-fade-in-stable" style={{ animationDelay: '0.2s', animationFillMode: 'both' }}>Advertise your off-market deals through an intuitive and affordable marketplace.</p>
          <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center animate-fade-in-stable" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
            <Link to="/seller/register">
              <Button size="lg" className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90 w-full sm:w-auto hover-lift group">
                Create Account 
                <ArrowRight className="ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/login">
              <Button size="lg" variant="outline" className="border-godyspo-gold text-godyspo-gold w-full sm:w-auto hover-lift">
                Sign In
              </Button>
            </Link>
          </div>
          
          {/* Mobile App Badge */}
          <div className="flex flex-col items-center gap-2 pt-2 animate-fade-in-stable" style={{ animationDelay: '0.4s', animationFillMode: 'both' }}>
            <span className="text-sm text-muted-foreground">Also available on mobile</span>
            <a 
              href="https://play.google.com/store/apps/details?id=app.lovable.a458feef936a4fdd9306ef7eae220648"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform hover:scale-105"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                className="h-14"
              />
            </a>
          </div>
          
          {/* Property listing screenshot section */}
          <div className="mt-12 relative rounded-lg overflow-hidden shadow-2xl" style={{ aspectRatio: '16/9' }}>
            <OptimizedImage 
              src="/lovable-uploads/e5a4ee17-be3d-494a-a267-831704df6e99.png"
              alt="GoDyspo Property Listing Interface" 
              className="w-full h-auto rounded-lg" 
              priority={true}
              width={1200}
              height={675}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
            />
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;